import React from 'react';
import { Facebook, Instagram, Twitter, MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-4xl font-light text-white mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Pazzo</h3>
            <p className="text-zinc-500 mb-6 font-light text-sm leading-relaxed">
              Local pizzeria serving the finest handcrafted pizzas and delicious food.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-zinc-500 hover:text-white transition-colors">
                <Facebook size={18} strokeWidth={1.5} />
              </a>
              <a href="#" className="text-zinc-500 hover:text-white transition-colors">
                <Instagram size={18} strokeWidth={1.5} />
              </a>
              <a href="#" className="text-zinc-500 hover:text-white transition-colors">
                <Twitter size={18} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-normal mb-6 tracking-wide uppercase text-sm">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-zinc-500 hover:text-white transition-colors font-light text-sm"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-zinc-500 hover:text-white transition-colors font-light text-sm"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('gallery')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-zinc-500 hover:text-white transition-colors font-light text-sm"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('locations')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-zinc-500 hover:text-white transition-colors font-light text-sm"
                >
                  Location
                </button>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h4 className="text-white font-normal mb-6 tracking-wide uppercase text-sm">Opening Hours</h4>
            <ul className="space-y-3 text-zinc-500 font-light text-sm">
              <li className="flex justify-between">
                <span>Monday - Thursday</span>
                <span className="text-white">10:30 - 21:00</span>
              </li>
              <li className="flex justify-between">
                <span>Friday</span>
                <span className="text-white">10:30 - 22:00</span>
              </li>
              <li className="flex justify-between">
                <span>Saturday</span>
                <span className="text-white">11:00 - 22:00</span>
              </li>
              <li className="flex justify-between">
                <span>Sunday</span>
                <span className="text-white">11:00 - 21:00</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-normal mb-6 tracking-wide uppercase text-sm">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-zinc-500 font-light text-sm">
                <MapPin className="text-white flex-shrink-0 mt-1" size={16} strokeWidth={1.5} />
                <span>Kirkonkyläntie 34, 00700 Helsinki</span>
              </li>
              <li className="flex items-center gap-3 text-zinc-500 font-light text-sm">
                <Phone className="text-white flex-shrink-0" size={16} strokeWidth={1.5} />
                <span>0413289889</span>
              </li>
              <li className="flex items-center gap-3 text-zinc-500 font-light text-sm">
                <Mail className="text-white flex-shrink-0" size={16} strokeWidth={1.5} />
                <span>info@pazzo.fi</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-zinc-800 mt-12 pt-8 text-center">
          <p className="text-zinc-600 font-light text-sm">
            © {currentYear} Pazzo Italian Pizzeria. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;